import React from 'react'
import { orderBy } from 'lodash'

import { getLocaleDateStringFull, cutString2 } from '../../../helpers/functions'
import { CREATE_BOOKING } from '../../../helpers/constants'
import { IMG } from '../../../themes'
import Bullet from './Bullet'

const YearViewModal = (props) => {
  const {
    language,
    date,
    bookings,
    onBookingView,
    onClose,
    colorTheme,
  } = props

  const bullet = (
    <Bullet
      colorTheme={colorTheme}
      width='10px'
      height='10px'
    />
  )

  return (
    <div className='card'>
      <div className='data-list'>
        <img className='more_content_delete' src={IMG['close.svg']} onClick={onClose} alt='close' />

        <div className='title_year'>
          {getLocaleDateStringFull(new Date(date), language)}
        </div>

        <div className='data-list-year'>
          {bookings.length > 0
            ? orderBy(bookings, 'startTime', 'asc').map((item, index) => (
                <div
                  key={`year-booking-${index}`}
                  className='list-year'
                  onClick={() => onBookingView(item)}
                >
                  {bullet}
                  <span className='sub_title_year'>{cutString2(`${item.startTime} ${item.title}`, 25)}</span>
                </div>
              ))
            : (
              <div className='list-year'>
                {bullet}
                <span className='sub_title_year'>{CREATE_BOOKING.NO_DATA[language]}</span>
              </div>
            )
          }
        </div>
      </div>
    </div>
  )
}

export default YearViewModal
